/**
 * Всплывающее уведомление.
 */
/** Компонент для сокгласия с куками */
class Cookie {
    /**
     * Создает компонент уведы о куках.
     *
     * @param {HTMLDivElement} div Блок уведы.
     */
    constructor(div) {
        this.el = div;
        this.btn = this.el.querySelector(".js-cookies-notification-btn");
        this.cookieName = this.el.dataset.cookie;
        this.bindEventListeners();
    }

    /**
     * Привязка обработчиков событий.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.btn.addEventListener("click", (e) => {
            e.preventDefault();
            BX.setCookie(this.cookieName, "Y", {
                expires: 86400*365,
                path: "/",
            });
            this.el.remove();
        });
    }
}
window.addEventListener("load", function() {
    BX.ready(function() {
        document.querySelectorAll(".js-cookies-notification").forEach(el => new Cookie(el));
    });
});
